import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { Mail, ArrowLeft } from 'lucide-react';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // idle, loading, success, error

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');
        try {
            // Call our new Public Endpoint
            await api.post('auth/forgot-password/', { email });
            setStatus('success');
        } catch (err) {
            setStatus('error');
        }
    };

    if (status === 'success') {
        return (
            <div style={{minHeight:'100vh', background:'#0f172a', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px'}}>
                <div style={{background:'#1e293b', padding:'40px', borderRadius:'12px', border:'1px solid #334155', maxWidth:'400px', width:'100%', textAlign:'center'}}>
                    <div style={{background:'rgba(16, 185, 129, 0.2)', width:'60px', height:'60px', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px'}}>
                        <Mail size={30} color="#10b981" />
                    </div>
                    <h2 style={{color:'white', marginBottom:'10px'}}>Check your inbox</h2>
                    <p style={{color:'#94a3b8', marginBottom:'30px'}}>
                        We've sent a password reset link to <strong>{email}</strong>.
                    </p>
                    <Link to="/login" style={{color:'#3b82f6', textDecoration:'none'}}>Back to Login</Link>
                </div>
            </div>
        );
    }

    return (
        <div style={{minHeight:'100vh', background:'#0f172a', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px'}}>
            <div style={{background:'#1e293b', padding:'40px', borderRadius:'12px', border:'1px solid #334155', maxWidth:'400px', width:'100%'}}>
                <h2 style={{color:'white', marginBottom:'10px', textAlign:'center'}}>Reset Password</h2>
                <p style={{color:'#94a3b8', marginBottom:'30px', textAlign:'center', fontSize:'0.9rem'}}>
                    Enter your email and we'll send you a link to get back into your account.
                </p>
                
                <form onSubmit={handleSubmit}>
                    <div style={{marginBottom:'20px'}}>
                        <label style={{display:'block', color:'#94a3b8', marginBottom:'8px', fontSize:'0.9rem'}}>Email Address</label>
                        <input 
                            type="email" 
                            required 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{width:'100%', padding:'12px', background:'#0f172a', border:'1px solid #334155', borderRadius:'8px', color:'white', boxSizing:'border-box'}}
                        />
                    </div>
                    <button 
                        type="submit" 
                        disabled={status === 'loading'}
                        style={{width:'100%', padding:'12px', background:'#3b82f6', color:'white', border:'none', borderRadius:'8px', fontWeight:'bold', cursor:'pointer', opacity: status === 'loading' ? 0.7 : 1}}
                    >
                        {status === 'loading' ? 'Sending...' : 'Send Link'}
                    </button>
                </form>

                <div style={{marginTop:'20px', textAlign:'center'}}>
                    <Link to="/login" style={{color:'#94a3b8', textDecoration:'none', fontSize:'0.9rem', display:'inline-flex', alignItems:'center', gap:'5px'}}>
                        <ArrowLeft size={14} /> Back to Login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;